import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {useCallback, useEffect, useState, useMemo } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {push} from 'connected-react-router'
import styled from 'styled-components'
import {PrimaryButton} from './index'
import { registerCard, retrievePaymentMethod } from '../reducks/users/operations'
import TextDetail from './TextDetail'
import { getCustomerId, getPaymentMethodId } from '../reducks/users/selectors'
// mui
import Button from '@material-ui/core/Button'

const PaymentEdit = () => {
    const dispatch = useDispatch()
    const stripe = useStripe()
    const elements = useElements()
    const selector = useSelector(state=>state)
    const customerId = getCustomerId(selector)
    const paymentMethodId = getPaymentMethodId(selector)
    const [card, setCard] = useState({})

    // カード情報の登録
    const register = useCallback(() => {
        dispatch(registerCard(stripe, elements, customerId))
    },[stripe, elements, customerId, dispatch])

    useEffect(() => {
        (async () => {
            const cardData = await retrievePaymentMethod(paymentMethodId)
            if (cardData) { setCard(cardData) }
        })()
    },[paymentMethodId])

    const cardBrand = useMemo(() => {
        if (card.brand) {
            return card.brand.toUpperCase()
        } else {
            return '----'
        }
    }, [card])

    const cardNumber = useMemo(() => {
        if (card.last4) {
            return "**** **** **** " + card.last4
        } else {
            return '未登録'
        }
    }, [card])

    return (
        <Wrapper>
            <div className='spacer-100' />
            <h1 style={{textAlign: 'center'}}>カード情報の編集</h1>
            <div className='spacer-50' />
            <p style={{textAlign: 'left'}}>現在登録されているカード情報</p>
            <TextDetail label={cardBrand} value={cardNumber} />
            <div className='spacer-50' />
            <CardElement
                options={{
                    iconStyle: 'solid',
                    style: {
                        base: {
                            fontSize: '16px',
                            color: '#7ABECE',
                            '::placeholder': {
                                color: '#aab7c4',
                            },
                        },
                        invalid: {
                            color: '#9e2146',
                        },
                    },
                }}
            />
            <div className='spacer-100' />
            <PrimaryButton label='カード情報を登録する' operation={()=>register()}/>
            <div className='spacer-25' />
            <Button onClick={()=>dispatch(push('/mypage'))}>マイページに戻る</Button>
            <div className='spacer-100' />

        </Wrapper>
    )
}

export default PaymentEdit

const Wrapper = styled.div`
    width: 400px;
    margin: 0 auto;
    text-align: center;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`